import { Page } from '../components';
import { UploadAnalyzeForm } from '../forms';

export const UploadAnalyze = () => (
  <Page render={() => <UploadAnalyzeForm />} />
);
